import type { CatalogApi } from '../features/catalog/model';

/** Matches a platform card against its complete, non-display catalog corpus. */
export const matchesCatalogCard = (api: CatalogApi, query: string): boolean => {
  const normalized = query.trim().toLowerCase();
  return normalized === '' || api.searchText.toLowerCase().includes(normalized);
};
